import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import Parallax from "./Parallax"
import Sizing from "./Sizing"
import HungerImages from "../imageQueries/Hunger"
import DiseaseImages from "../imageQueries/Disease"
import RentsImages from "../imageQueries/Rents"
import ClimateImages from "../imageQueries/Climate"
import BoredomImages from "../imageQueries/Boredom"
import RacismImages from "../imageQueries/Racism"

const Motif = ({ page, id, movement = 0, rotation = 0, offsetY = 0 }) => {
    const data = {}
    data.hunger = HungerImages
    data.disease = DiseaseImages
    data.rents = RentsImages
    data.climate = ClimateImages
    data.boredom = BoredomImages
    data.racism = RacismImages

    const Imgs = data[page]

    if (!movement) {
        return <Imgs id={id} />
    }

    return (
        <Parallax movement={movement} rotation={rotation}>
            <Sizing
                styles={{ position: "relative" }}
                breaks={[
                    {
                        min: 0,
                        val: {
                            width: "200%",
                            left: "-50%",
                        },
                    },
                    {
                        min: 1024,
                        val: {
                            width: "100%",
                            left: "0",
                            marginTop: offsetY,
                        },
                    },
                ]}
            >
                <Imgs id={id} />
            </Sizing>
        </Parallax>
    )
}

export default Motif
